export const PARAM_NAME = {
  BONUS: 'bonusId',
  OFFER: 'offerId',
  CATEGORY: 'categoryId',
  PROVIDER: 'providerId',
  GAME: 'gameId',
  RULES: 'rulesId',
  PAGE: 'page',
};

export const PAGINATION_TEMPLATE = `/page/:${PARAM_NAME.PAGE}?`;

export const ROOT = '/';
export const GAME = `/game/:${PARAM_NAME.GAME}`;
export const DEMO_GAME = `/demo-game/:${PARAM_NAME.GAME}`;
export const SPECIAL_OFFERS = '/special-offers';
export const SPECIAL_OFFER_PAGE = `${SPECIAL_OFFERS}/:${PARAM_NAME.OFFER}`;
export const BONUSES = '/bonuses';
export const BONUSES_COLLECTING_GAMES = '/collecting-games';
export const BONUSES_WAGERING_GAMES = '/wagering-games';
export const BONUSES_WAGERING_GAMES_SCCOM = '/bonuses/games/wagering';
export const BONUS_HISTORY = '/bonus-history';
export const BONUS_PAGE = `${BONUSES}/:${PARAM_NAME.BONUS}`;
export const SEARCH = '/search';
export const RULES = '/rules';
export const RULES_DETAIL = `/rules/:${PARAM_NAME.RULES}`;
export const HALL_OF_FAME = '/hall-of-fame';
export const HALL_OF_FAME_HISTORY = '/hall-of-fame/history';
export const COMMON_ERROR = '/:status([4,5]\\d{2})';
export const NO_MATCH = '*';
export const CATEGORY_LIST = '/categories';
export const CATEGORY_DETAIL = `/categories/:${PARAM_NAME.CATEGORY}`;
export const PROVIDER_LIST = '/providers';
export const PROVIDER_DETAIL = `/providers/:${PARAM_NAME.PROVIDER}`;
export const PROVIDER_DETAIL_PAGINATED = `${PROVIDER_DETAIL}${PAGINATION_TEMPLATE}`;
export const CATEGORY_DETAIL_PAGINATED = `${CATEGORY_DETAIL}${PAGINATION_TEMPLATE}`;
export const TOURNAMENTS = '/casino-tournaments';

export const ROUTES = {
  ROOT,
  GAME,
  DEMO_GAME,
  SPECIAL_OFFERS,
  SPECIAL_OFFER_PAGE,
  BONUSES,
  BONUSES_COLLECTING_GAMES,
  BONUSES_WAGERING_GAMES,
  BONUSES_WAGERING_GAMES_SCCOM,
  BONUS_HISTORY,
  BONUS_PAGE,
  SEARCH,
  RULES,
  RULES_DETAIL,
  HALL_OF_FAME,
  HALL_OF_FAME_HISTORY,
  COMMON_ERROR,
  NO_MATCH,
  CATEGORY_LIST,
  CATEGORY_DETAIL,
  PROVIDER_LIST,
  PROVIDER_DETAIL,
  PROVIDER_DETAIL_PAGINATED,
  CATEGORY_DETAIL_PAGINATED,
};

// Aliases

export const ROUTE_ALIASES = {
  [CATEGORY_DETAIL_PAGINATED]: [CATEGORY_DETAIL],
  [PROVIDER_DETAIL_PAGINATED]: [PROVIDER_DETAIL],
};

export const ALL_ROUTES_VALUES = Object.values(ROUTES);
